import React from "react";
import CERequirements, { CeRequirementsParams } from "components/CeRequirements";
import Layout from "components/common/Layout";
import { CE_REQUIREMENTS_SLUG } from "constants/urls";
import { getServerSideSEO, SeoPageProps } from "helpers/seo";
import { withEnhancedServerSideProps } from "helpers/withEnhancedProps";

const CeRequirementsPage = ({ seo, title }: SeoPageProps) => {
  return (
    <Layout initialMeta={seo}>
      <CERequirements title={title} seo={seo} />
    </Layout>
  );
};

export default CeRequirementsPage;

const PAGE_TITLE = "CE Requirements";

export const getServerSideProps = withEnhancedServerSideProps<SeoPageProps, CeRequirementsParams>(
  async ctx => {
    if (ctx.isInitialRequest) {
      const seoProps = await getServerSideSEO(ctx, CE_REQUIREMENTS_SLUG, PAGE_TITLE);

      return {
        props: seoProps,
      };
    }

    return {
      props: { title: PAGE_TITLE },
    };
  }
);
